import { type CaptionVideoTask } from '~/components/CaptionVideoTasks/types';
import { type AssetTransformationTask } from '~/store/tasks/types';

/**
 * Type predicate to narrow AssetTransformationTask to CaptionVideoTask.
 */
export const isCaptionVideoTask = (task: AssetTransformationTask): task is CaptionVideoTask =>
  task.metadata.transformType === 'captionVideo';
